import { createAction, props } from '@ngrx/store';

export class RewardTag {
  id?: string;
  identifier: string;
  tag: string;
  description: string;
  tagName: string;
  name?: string;
  type: string;
}

export const rewardTagRequested = createAction(
  '[REWARD_TAG] Reward Tag goal requested'
);

export const rewardTagLoaded = createAction(
  '[REWARD_TAG] Reward Tag goal loaded',
  props<{ rewardTag: RewardTag[] }>()
);

